import { useState, useEffect } from 'react';
import { servicesAPI } from '../../services/api';
import toast from 'react-hot-toast';

const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };
const VEHICLE_TYPES = [
  { value:'hatch',  label:'Hatch' },
  { value:'sedan',  label:'Sedan' },
  { value:'suv',    label:'SUV' },
  { value:'pickup', label:'Caminhonete/Pickup' },
  { value:'van',    label:'Van' },
  { value:'truck',  label:'Caminhão' },
  { value:'moto',   label:'Moto' },
  { value:'other',  label:'Outros' },
];

const defaultPrices = () => VEHICLE_TYPES.reduce((a, t) => ({ ...a, [t.value]: '' }), {});

export default function ServiceList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading]   = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm]         = useState({ name:'', description:'', estimated_minutes:60, is_active:1 });
  const [prices, setPrices]     = useState(defaultPrices());
  const [editing, setEditing]   = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const r = await servicesAPI.list();
      setServices(r.data.data || []);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const startNew = () => {
    setEditing(null); setForm({ name:'', description:'', estimated_minutes:60, is_active:1 }); setPrices(defaultPrices()); setShowForm(true);
  };

  const startEdit = async (s) => {
    setEditing(s);
    setForm({ name:s.name, description:s.description||'', estimated_minutes:s.estimated_minutes||60, is_active:s.is_active ?? 1 });
    const r = await servicesAPI.show(s.id).catch(() => ({ data:{ data:{ prices:{} } } }));
    const p = r.data.data?.prices || {};
    setPrices({ ...defaultPrices(), ...Object.fromEntries(Object.entries(p).map(([k,v]) => [k, v||''])) });
    setShowForm(true);
  };

  const save = async (e) => {
    e.preventDefault();
    try {
      const pricesPayload = Object.fromEntries(
        Object.entries(prices).filter(([,v]) => v !== '').map(([k,v]) => [k, parseFloat(v)])
      );
      const payload = { ...form, prices: pricesPayload };
      if (editing) {
        await servicesAPI.update(editing.id, payload);
      } else {
        await servicesAPI.create(payload);
      }
      toast.success(editing ? 'Serviço atualizado!' : 'Serviço criado!');
      setShowForm(false); load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
  };

  const del = async (id) => {
    if (!window.confirm('Remover serviço?')) return;
    try { await servicesAPI.delete(id); toast.success('Removido.'); load(); }
    catch { toast.error('Erro ao remover.'); }
  };

  const fmt = v => v ? `R$ ${parseFloat(v).toFixed(2).replace('.',',')}` : '—';

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Serviços</h1>
        <button onClick={startNew} style={{ background:'#2563EB', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:600, cursor:'pointer' }}>+ Novo Serviço</button>
      </div>

      {loading && <p style={{ color:'#9CA3AF', textAlign:'center', padding:40 }}>Carregando...</p>}

      <div style={{ display:'grid', gap:12 }}>
        {services.map(s => (
          <div key={s.id} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:'18px 20px', display:'flex', gap:16, alignItems:'flex-start' }}>
            <div style={{ flex:1 }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:4 }}>
                <span style={{ fontWeight:700, color:'#0F172A', fontSize:'1rem' }}>{s.name}</span>
                <span style={{ background:s.is_active?'#D1FAE5':'#F3F4F6', color:s.is_active?'#065F46':'#6B7280', borderRadius:6, padding:'2px 8px', fontSize:'.7rem', fontWeight:600 }}>
                  {s.is_active ? 'Ativo' : 'Inativo'}
                </span>
              </div>
              {s.description && <p style={{ color:'#6B7280', fontSize:'.85rem', margin:'0 0 8px' }}>{s.description}</p>}
              <div style={{ fontSize:'.8rem', color:'#9CA3AF' }}>Duração: {s.estimated_minutes} min</div>
              {s.prices && Object.keys(s.prices).length > 0 && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:10 }}>
                  {Object.entries(s.prices).map(([type, price]) => (
                    <span key={type} style={{ background:'#EFF6FF', color:'#1D4ED8', borderRadius:6, padding:'3px 10px', fontSize:'.75rem', fontWeight:600 }}>
                      {type.charAt(0).toUpperCase()+type.slice(1)}: {fmt(price)}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div style={{ display:'flex', gap:8, flexShrink:0 }}>
              <button onClick={()=>startEdit(s)} style={{ background:'#EFF6FF', color:'#2563EB', border:'none', borderRadius:6, padding:'6px 14px', cursor:'pointer', fontWeight:600, fontSize:'.8rem' }}>Editar</button>
              <button onClick={()=>del(s.id)} style={{ background:'#FEF2F2', color:'#DC2626', border:'none', borderRadius:6, padding:'6px 14px', cursor:'pointer', fontWeight:600, fontSize:'.8rem' }}>Remover</button>
            </div>
          </div>
        ))}
        {!loading && services.length === 0 && (
          <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>Nenhum serviço cadastrado.</div>
        )}
      </div>

      {showForm && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.5)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
          <div style={{ background:'#fff', borderRadius:16, padding:32, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ fontWeight:700, marginBottom:20, color:'#0F172A' }}>{editing?'Editar':'Novo'} Serviço</h3>
            <form onSubmit={save}>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Nome do serviço *</label>
                <input value={form.name} onChange={e=>set('name',e.target.value)} required style={inp} placeholder="Ex: Lavagem completa" />
              </div>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Descrição</label>
                <textarea value={form.description} onChange={e=>set('description',e.target.value)} rows={2} style={{ ...inp, resize:'vertical' }} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={lbl}>Duração (minutos)</label>
                  <input type="number" value={form.estimated_minutes} onChange={e=>set('estimated_minutes',e.target.value)} min={5} style={inp} />
                </div>
                <div>
                  <label style={lbl}>Status</label>
                  <select value={form.is_active} onChange={e=>set('is_active',Number(e.target.value))} style={inp}>
                    <option value={1}>Ativo</option>
                    <option value={0}>Inativo</option>
                  </select>
                </div>
              </div>
              <div style={{ marginBottom:4 }}>
                <label style={{ ...lbl, marginBottom:10 }}>Preços por tipo de veículo</label>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                  {VEHICLE_TYPES.map(t => (
                    <div key={t.value}>
                      <label style={{ ...lbl, fontWeight:400, fontSize:'.75rem' }}>{t.label}</label>
                      <input type="number" step="0.01" min="0" value={prices[t.value]} onChange={e=>setPrices(p=>({...p,[t.value]:e.target.value}))}
                        placeholder="R$ 0,00" style={inp} />
                    </div>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:20 }}>
                <button type="button" onClick={()=>setShowForm(false)} style={{ padding:'10px 20px', border:'1.5px solid #E5E7EB', borderRadius:8, background:'#fff', cursor:'pointer' }}>Cancelar</button>
                <button type="submit" style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer' }}>Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
